import { render } from "./BaseTableElement.vue?vue&type=template&id=32bf36ae&scoped=true&ts=true"
import script from "./BaseTableElement.vue?vue&type=script&lang=ts"
export * from "./BaseTableElement.vue?vue&type=script&lang=ts"

import "./BaseTableElement.vue?vue&type=style&index=0&id=32bf36ae&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bf36ae"]])

export default __exports__